import { bootstrapWithApm } from "@frontends-v3/shared-core";

import pkg from "../package.json";

import { appConfig } from "./app/app.config";
import { App } from "./app/app";
import { environment } from "./environments/environment";

const APP_VERSION = pkg.version;

// Cadeia de promise em vez de IIFE async: com Zone.js o build rebaixa async/await, e um IIFE async
// no entry faz o esbuild embrulhar os módulos em inicialização lazy, desligando o tree-shaking das libs.
bootstrapWithApm({
  appComponent: App,
  appConfig,
  environment,
  serviceVersion: APP_VERSION
}).catch((err: unknown) => {
  console.error(err);
});
